const { Sortable } = require("@shopify/draggable");
const { default: axios } = require("axios");


const ProductSort = function () {

    const productSort = function () {

        const div = document.querySelector('.product-sort');

        new Sortable(div, {
            draggable: '.draggable',
            handle: '.draggable .draggable-handle',
            mirror: {
                appendTo: 'body',
                constrainDimensions: true
            }
        }).on('sortable:stop', function (response) {
            setTimeout(() => {
                let container = response.data.newContainer.id;

                var url = $('#' + container).attr('data-url');
                let sorting = [];

                $('#' + container).find('.draggable').each(function (index) {
                    var el = $(this);
                    sorting[index] = el.attr('data-id');
                    $(el).find('.item-sorting').text(index);
                });

                axios.post(url, { sorting: sorting })
                    .then(function (response) {
                        let data = response.data;

                        console.log(data);

                    }).catch(function (error) {
                        console.error('Error during AJAX request:', error);
                    });

            }, 500);
        });
    }

    return {
        init: function () {
            if ($('.product-sort').length > 0) {
                productSort();
            }
        }
    }
}();

module.exports = ProductSort;